module.exports = __webpack_public_path__ + "img/China.d1052ca5.svg";